<div class="modal" data-id="acc-modal" hidden>
  <div class="modal__backdrop" data-id="acc-backdrop"></div>

  <form class="modal__dialog modal__dialog--wizard" data-id="acc-form-el" role="dialog" aria-modal="true"
        aria-labelledby="acc-form-title" novalidate>
    <header class="modal__header">
      <h2 class="modal__title" id="acc-form-title" data-id="acc-title"><%= _lcs( 'Neue Unterkunft anlegen' ) %></h2>
      <button type="button" class="iconbtn modal__close" data-id="acc-close" aria-label="<%= _lcs( 'Schließen' ) %>">
        <i class="icon icon--x"></i>
      </button>
    </header>

    <!-- Step indicator -->
    <ol class="wizard-steps" data-id="acc-steps">
      <li class="wizard-steps__item is-active" data-step-indicator="0">
        <span class="wizard-steps__marker"><i class="icon icon--building-2"></i></span>
        <span class="wizard-steps__label"><%= _lcs( 'Basis' ) %></span>
      </li>
      <li class="wizard-steps__item" data-step-indicator="1">
        <span class="wizard-steps__marker"><i class="icon icon--mail"></i></span>
        <span class="wizard-steps__label"><%= _lcs( 'Kontakt' ) %></span>
      </li>
      <li class="wizard-steps__item" data-step-indicator="2">
        <span class="wizard-steps__marker"><i class="icon icon--check"></i></span>
        <span class="wizard-steps__label"><%= _lcs( 'Übersicht' ) %></span>
      </li>
    </ol>

    <div class="modal__body">
      <!-- ===================== Step 1 · Basis ===================== -->
      <section class="wizard-panel" data-step-panel="0">
        <div class="field">
          <label class="field__label" for="acc-name"><%= _lcs( 'Name' ) %></label>
          <div class="field__control">
            <span class="field__icon"><i class="icon icon--building-2"></i></span>
            <input class="field__input" id="acc-name" name="name" type="text"
                   autocomplete="off" placeholder="<%= _lcs( 'Musterhotel' ) %>" required
                   data-msg-required="<%= _lcs( 'Bitte gib einen Namen ein.' ) %>" />
          </div>
        </div>

        <div class="field">
          <label class="field__label" for="acc-slug"><%= _lcs( 'Slug (Subdomain)' ) %></label>
          <div class="field__control field__control--affixed">
            <span class="field__affix">https://</span>
            <input class="field__input" id="acc-slug" name="slug" type="text"
                   autocomplete="off" placeholder="musterhotel" maxlength="63" required
                   data-msg-required="<%= _lcs( 'Bitte gib einen Slug (Subdomain) ein.' ) %>" />
            <span class="field__affix field__affix--suffix">.belturo.app</span>
          </div>
          <p class="field__note">
            <i class="icon icon--shield-check"></i>
            <%= _lcs( 'Nur Kleinbuchstaben, Ziffern und Bindestriche. Muss eindeutig sein.' ) %>
          </p>
        </div>

        <div class="field">
          <label class="field__label" for="acc-type"><%= _lcs( 'Typ' ) %></label>
          <div class="field__control">
            <span class="field__icon"><i class="icon icon--home"></i></span>
            <!-- Only "guesthouse" is offered for now — the other types stay
                 visible but disabled until the platform supports them. -->
            <select class="field__input field__select" id="acc-type" name="type">
              <option value="hotel" disabled>Hotel</option>
              <option value="airbnb" disabled>Airbnb</option>
              <option value="apartment" disabled>Apartment</option>
              <option value="guesthouse"><%= _lcs( 'Gästehaus' ) %></option>
              <option value="bnb" disabled>B&amp;B</option>
              <option value="hostel" disabled>Hostel</option>
              <option value="camping" disabled>Camping</option>
              <option value="other" disabled><%= _lcs( 'Sonstige' ) %></option>
            </select>
          </div>
        </div>

        <div class="field">
          <label class="field__label" for="acc-region"><%= _lcs( 'Region' ) %></label>
          <div class="field__control">
            <span class="field__icon"><i class="icon icon--map-pin"></i></span>
            <select class="field__input field__select" id="acc-region" name="region">
              <option value="saechsische_schweiz"><%= _lcs( 'Sächsische Schweiz' ) %></option>
            </select>
          </div>
        </div>

        <div class="field">
          <label class="field__label" for="acc-status"><%= _lcs( 'Status' ) %></label>
          <div class="field__control">
            <span class="field__icon"><i class="icon icon--circle-check"></i></span>
            <select class="field__input field__select" id="acc-status" name="status">
              <option value="draft"><%= _lcs( 'Entwurf' ) %></option>
              <option value="published"><%= _lcs( 'Veröffentlicht' ) %></option>
            </select>
          </div>
          <p class="field__note">
            <i class="icon icon--eye"></i>
            <%= _lcs( 'Nur veröffentlichte Unterkünfte sind für Gäste sichtbar (Guest-App & Gästemappe).' ) %>
          </p>
        </div>

        <!-- Owner is required on create; fixed (disabled) in edit mode -->
        <div class="field" data-id="acc-owner-field">
          <label class="field__label" for="acc-owner"><%= _lcs( 'Eigentümer (Client)' ) %></label>
          <div class="field__control">
            <span class="field__icon"><i class="icon icon--user-round"></i></span>
            <select class="field__input field__select" id="acc-owner" name="ownerUserId" required
                    data-msg-required="<%= _lcs( 'Bitte wähle einen Eigentümer (Client) aus.' ) %>">
              <option value=""><%= _lcs( 'Bitte wählen …' ) %></option>
            </select>
          </div>
        </div>

        <div class="field">
          <label class="field__label" for="acc-timezone"><%= _lcs( 'Zeitzone' ) %></label>
          <div class="field__control">
            <span class="field__icon"><i class="icon icon--clock"></i></span>
            <select class="field__input field__select" id="acc-timezone" name="timezone"></select>
          </div>
        </div>
      </section>

      <!-- ===================== Step 2 · Kontakt ===================== -->
      <section class="wizard-panel" data-step-panel="1" hidden>
        <div class="field">
          <label class="field__label" for="acc-www"><%= _lcs( 'Webseite (optional)' ) %></label>
          <div class="field__control">
            <span class="field__icon"><i class="icon icon--layout-template"></i></span>
            <input class="field__input" id="acc-www" name="www" type="url"
                   autocomplete="off" placeholder="https://www.musterhotel.de" />
          </div>
        </div>

        <div class="field">
          <label class="field__label" for="acc-email"><%= _lcs( 'E-Mail (optional)' ) %></label>
          <div class="field__control">
            <span class="field__icon"><i class="icon icon--mail"></i></span>
            <input class="field__input" id="acc-email" name="email" type="email"
                   autocomplete="off" placeholder="info@musterhotel.de" />
          </div>
        </div>

        <div class="field">
          <label class="field__label" for="acc-phone"><%= _lcs( 'Telefon (optional)' ) %></label>
          <div class="field__control">
            <span class="field__icon"><i class="icon icon--phone"></i></span>
            <input class="field__input" id="acc-phone" name="phone" type="tel"
                   autocomplete="off" placeholder="+49 35022 12345" />
          </div>
        </div>

        <p class="field__note"><strong><%= _lcs( 'Adresse' ) %></strong> — <%= _lcs( 'Ausgangspunkt aller Entfernungen in der Gäste-App; die Koordinaten werden beim Speichern ermittelt.' ) %></p>

        <div class="field">
          <label class="field__label" for="acc-street"><%= _lcs( 'Straße' ) %></label>
          <div class="field__control">
            <span class="field__icon"><i class="icon icon--map-pin"></i></span>
            <input class="field__input" id="acc-street" name="street" type="text"
                   autocomplete="off" placeholder="Hauptstraße 1" required
                   data-msg-required="<%= _lcs( 'Bitte gib Straße und Hausnummer ein.' ) %>" />
          </div>
        </div>

        <div class="field">
          <label class="field__label" for="acc-postalCode"><%= _lcs( 'PLZ' ) %></label>
          <div class="field__control">
            <span class="field__icon"><i class="icon icon--map-pin"></i></span>
            <input class="field__input" id="acc-postalCode" name="postalCode" type="text"
                   autocomplete="off" placeholder="01814" required
                   data-msg-required="<%= _lcs( 'Bitte gib die PLZ ein.' ) %>" />
          </div>
        </div>

        <div class="field">
          <label class="field__label" for="acc-city"><%= _lcs( 'Stadt' ) %></label>
          <div class="field__control">
            <span class="field__icon"><i class="icon icon--map-pin"></i></span>
            <input class="field__input" id="acc-city" name="city" type="text"
                   autocomplete="off" placeholder="Bad Schandau" required
                   data-msg-required="<%= _lcs( 'Bitte gib den Ort ein.' ) %>" />
          </div>
        </div>

        <div class="field">
          <label class="field__label" for="acc-countryCode"><%= _lcs( 'Ländercode' ) %></label>
          <div class="field__control">
            <span class="field__icon"><i class="icon icon--flag"></i></span>
            <select class="field__input field__select" id="acc-countryCode" name="countryCode"></select>
          </div>
        </div>
      </section>

      <!-- ===================== Step 3 · Übersicht ===================== -->
      <section class="wizard-panel" data-step-panel="2" hidden>
        <p class="field__note"><strong><%= _lcs( 'Bitte überprüfe deine Eingaben.' ) %></strong></p>
        <dl class="modal__dl" data-id="acc-summary"></dl>
      </section>

      <p class="modal__error" data-id="acc-error" role="alert" hidden></p>
    </div>

    <footer class="modal__footer wizard-footer">
      <button type="button" class="btn btn--ghost btn--sm" data-id="acc-cancel"><%= _lcs( 'Abbrechen' ) %></button>
      <div class="wizard-footer__nav">
        <button type="button" class="btn btn--ghost btn--sm" data-id="acc-back" hidden>
          <i class="icon icon--arrow-left"></i>
          <%= _lcs( 'Zurück' ) %>
        </button>
        <button type="button" class="btn btn--primary btn--sm" data-id="acc-next">
          <%= _lcs( 'Weiter' ) %>
          <i class="icon icon--arrow-right"></i>
        </button>
        <button type="submit" class="btn btn--primary btn--sm" data-id="acc-submit" hidden>
          <span data-id="acc-submit-label"><%= _lcs( 'Anlegen' ) %></span>
          <i class="icon icon--check"></i>
        </button>
      </div>
    </footer>
  </form>
</div>
